import React from "react";
import ReactDOM from "react-dom/client"; // Ensure this import is correct
import { BrowserRouter } from "react-router-dom";
import App from "./App"; // Ensure this is correctly imported
import reportWebVitals from "./reportWebVitals";
import "./index.css";

const root = ReactDOM.createRoot(document.getElementById("root")); // Correct usage
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);

reportWebVitals();
